export default {
    list: {
        title: 'Vstupenky',
        empty: {
            title: 'Žádné vstupenky',
            subtitle: 'Vytvořte první vstupenku nebo naimportujte CSV.',
            cta: '+ Nová vstupenka'
        },
        columns: {
            code: 'Kód',
            used: 'Použito',
            buyer: 'Kupující',
            event: 'Akce',
            ticketset: 'Sada',
            createdAt: 'Vytvořeno',
            usedAt: 'Použito',
            phone: 'Telefon',
            email: 'E-mail',
            firstName: 'Jméno',
            lastName: 'Příjmení',
            ticketNumber: 'Číslo vstupenky',
            validUntil: 'Platí do',
            boughtAt: 'Zakoupeno'
        }
    },
    verify: {
        title: 'Ověření vstupenky',
        subtitle: 'Zadejte kód vstupenky pro zobrazení detailu a využití.',
        enterCode: 'Kód vstupenky',
        verify: 'Ověřit',
        newSearch: 'Nové hledání',
        notFound: 'Vstupenka nenalezena',
        error: 'Při ověřování došlo k chybě.',
        found: 'Nalezeno',
        email: 'E-mail',
        entries: 'Vstupů',
        people: 'Osob',
        entryPause: 'Pauza mezi vstupy (min)',
        purchased: 'Zakoupeno',
        validUntil: 'Platnost do',
        event: 'Akce',
        ticketset: 'Sada',
        price: 'Cenová hladina',
        zones: 'Zóny',
        noZones: 'Bez zón',
        slots: 'Sloty',
        noSlots: 'Bez slotů',
        usageForZone: 'Využití pro zónu',
        remains: 'Zbývá',
        usageLogs: 'Historie použití',
        showDebug: 'Q',
        debugData: 'Raw data'
    },
    filters: {
        search: 'Hledat (kód, jméno, e-mail)',
        event: 'Akce',
        ticketset: 'Sada vstupenek',
        used: 'Stav použití',
        usedAny: 'Vše',
        usedYes: 'Použito',
        usedNo: 'Nepoužito'
    },
    usedLabel: {
        used: 'Použito',
        unused: 'Nepoužito'
    },
    edit: {
        titleEdit: 'Upravit vstupenku · {code}',
        unsavedChanges: 'Máte neuložené změny. Opravdu zavřít?'
    },
    import: {
        title: 'Import vstupenek',
        steps: {
            upload: '1. Nahrát',
            mapping: '2. Mapování',
            preview: '3. Náhled',
            progress: '4. Importuji',
            result: '5. Hotovo'
        },
        dropzone: 'Přetáhni CSV nebo Excel soubor sem nebo klikni',
        columns:
            'CSV i XLSX, s hlavičkou i bez. Sloupce se mapují v dalším kroku, chybějící hodnoty lze doplnit pevnou hodnotou.',
        eventRequired: 'Vyberte akci pro import',
        event: 'Akce',
        eventPlaceholder: 'Vyberte akci',
        rowCount: '{n} řádků',
        ticketsetCount: '{n} sad',
        priceCount: '{n} cen',
        validRows: '{n} validních',
        invalidRows: '{n} chyb',
        confirmImport: 'Importovat {n} vstupenek',
        importing: 'Importuji {n} vstupenek…',
        truncated: 'Zobrazeno prvních 100 řádků z {n}.',
        onlyCsv: 'Pouze CSV soubory',
        onlyCsvXlsx: 'Pouze soubory CSV, XLS nebo XLSX',
        success: 'Import úspěšný',
        failed: 'Import selhal',
        failedNothingSaved: 'Import neproběhl — nebylo uloženo nic',
        blockingErrors: 'Import je atomický, {n} chyb je nutné opravit před odesláním:',
        rowLabel: 'Řádek {n}',
        backToList: 'Zpět na seznam',
        backToMapping: 'Zpět na mapování',
        anotherFile: 'Nahrát jiný soubor',
        mapping: {
            hasHeader: 'První řádek je hlavička',
            delimiter: 'Oddělovač',
            encoding: 'Kódování',
            sheet: 'List',
            headerUnsureAssumedHeader: 'První řádek považujeme za hlavičku — ověřte to prosím',
            headerUnsureAssumedData: 'První řádek považujeme za data — ověřte to prosím',
            headerUnsureHint:
                'Zkontrolujte v ukázce výše, jestli odhad sedí. Pokud ne, přepněte zaškrtávátko „První řádek je hlavička“ nebo upravte počet ignorovaných řádků.',
            headerConfirm: 'Je to správně',
            confirmHeaderFirst: 'Nejprve potvrďte, zda první řádek obsahuje hlavičku.',
            sampleTitle: 'Ukázka ze souboru',
            headerRowLabel: 'hlavička',
            skippedRowLabel: 'přeskočeno',
            skipRows: 'Ignorovat řádků na začátku',
            skipTrailingRows: 'Ignorovat na konci',
            fromColumn: 'Sloupec ze souboru',
            fixedValue: 'Pevná hodnota',
            existingTicketset: 'Existující sada',
            existingPrice: 'Existující cena',
            selectExisting: 'Vyberte ze seznamu',
            noExisting: 'V této akci zatím nic není',
            pickEventFirst: 'Pro výběr existující sady nejprve zvolte akci.',
            pickTicketsetFirst: 'Pro výběr existující ceny nejprve zvolte existující sadu.',
            autoFromExisting: 'Doplněno z vybrané položky',
            empty: 'Nevyplňovat',
            selectColumn: 'Vyberte sloupec',
            columnN: '{n}. sloupec',
            preview: 'Náhled',
            valuePlaceholder: 'Hodnota pro všechny řádky',
            appliesToAll: 'Použije se na všechny řádky',
            missingRequired: 'Vyplňte povinná pole: {fields}',
            continue: 'Pokračovat na náhled',
            reason: {
                alias: 'Podle názvu sloupce',
                fuzzy: 'Podle podobného názvu sloupce',
                content: 'Podle obsahu dat',
                position: 'Podle pořadí sloupců',
                none: ''
            }
        },
        result: {
            created: 'Vytvořeno vstupenek',
            skipped: 'Přeskočeno (duplicity)',
            ticketsetsCreated: 'Založeno sad',
            pricesCreated: 'Založeno cen',
            atomicHint:
                'V souboru je {n} chyb. Import je atomický: dokud nebudou opravené všechny, neuloží se žádná vstupenka.',
            errorsTruncated: 'Zobrazeno {shown} z {total} chyb.',
            downloadErrors: 'Stáhnout všechny chyby (CSV)'
        },
        preview: {
            row: '#',
            status: 'Stav',
            errors: 'Chyby',
            cols: {
                code: 'Kód',
                priceId: 'Cena ID',
                priceName: 'Cena',
                priceNoDph: 'Cena bez DPH',
                priceDph: 'DPH',
                priceAmount: 'Částka',
                currency: 'Měna',
                ticketsetId: 'Sada ID',
                ticketsetName: 'Sada',
                orderId: 'Objednávka',
                paymentSource: 'Zdroj platby',
                paymentType: 'Typ platby',
                orderDate: 'Datum objednávky',
                firstName: 'Jméno',
                lastName: 'Příjmení',
                phone: 'Telefon',
                email: 'E-mail'
            }
        }
    },
    bulk: {
        selected: '{n} vybráno',
        deleteAll: 'Smazat vybrané',
        addToClipboard: 'Vložit vybrané do schránky'
    },
    actions: {
        import: 'Import CSV',
        export: 'Export CSV',
        addToClipboard: 'Do schránky'
    },
    detail: {
        addToClipboard: 'Přidat do schránky'
    },
    confirm: {
        deleteTitle: 'Smazat vstupenku?',
        deleteMessage: 'Vstupenka {code} bude trvale odstraněna.',
        deleteBulkTitle: 'Smazat vybrané vstupenky?',
        deleteBulkMessage: 'Bude trvale odstraněno {n} vstupenek.'
    },
    toasts: {
        saved: 'Vstupenka uložena',
        created: 'Vstupenka vytvořena',
        deleted: 'Vstupenka smazána',
        bulkDeleted: 'Smazáno {n} vstupenek',
        exported: 'Export připraven',
        exportedPage: 'Exportováno {n} vstupenek z aktuální stránky',
        addedToClipboard: 'Vstupenka přidána do schránky',
        bulkAddedToClipboard: 'Přidáno {n} vstupenek do schránky'
    }
}
